import { render } from "./ExerciseKruskal.vue?vue&type=template&id=b0cee696"
import script from "./ExerciseKruskal.vue?vue&type=script&lang=js"
export * from "./ExerciseKruskal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__